import { render, staticRenderFns } from "./SortFragment.vue?vue&type=template&id=9c9bdfbc&scoped=true&"
import script from "./SortFragment.vue?vue&type=script&lang=js&"
export * from "./SortFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9bdfbc",
  null
  
)

export default component.exports